import * as React from 'react';
import { CoauthorInformation } from '../CoauthorInformation';
import {
  getCoauthorSectionStyle,
  getOverflowMenuItemStyles,
  getPersonaCoinStyles,
  CoauthorGalleryPalette,
} from '../Styles';
import { PersonaCoin } from '@fluentui/react/lib/Persona';
import { getInitials, BaseButton } from '@fluentui/react';
import { onRenderIcon } from './onRenderIcon';

/**
 * Function that will be used to render all of the coauthors as buttons with corresponding persona coins in the overflow menu
 * @param coauthor Coauthor that's information is being read from to create the section item
 */
export const getCoauthorSectionItem = (
  coauthor: CoauthorInformation,
  index: number,
  coauthors: CoauthorInformation[],
  palette: CoauthorGalleryPalette,
  fallBackUserImage?: string,
  onCoauthorMenuItemExecute?: (ev: React.MouseEvent<HTMLDivElement>, coauthor: CoauthorInformation) => void
): JSX.Element => {
  const coauthorMenuItemProps = {
    text: coauthor.name,
    id: `${coauthor.id}-MenuItem`,
    key: `coauthor-${index}`,
    secondaryText: coauthor.description,
    styles: getOverflowMenuItemStyles(palette),
    ariaSetsize: coauthors.length,
    ariaPosInSet: index + 1,
    role: 'menuitem',
    disabled: !coauthor.hasRing,
    onClick: (ev: React.MouseEvent<HTMLDivElement>) => {
      onCoauthorMenuItemExecute && onCoauthorMenuItemExecute(ev, coauthor);
    },
    onRenderIcon: () => (
      <PersonaCoin
        imageUrl={coauthor.imageUrl}
        imageShouldStartVisible={true}
        coinSize={palette.overflowCoinSize}
        imageInitials={getInitials(coauthor.name, false)}
        initialsColor={coauthor.color}
        showInitialsUntilImageLoads={true}
        onRenderInitials={
          getInitials(coauthor.name, false) === '' || coauthor.isAnonymous
            ? onRenderIcon(palette.overflowCoinSize, fallBackUserImage)
            : undefined
        }
        styles={{ coin: getPersonaCoinStyles(palette, coauthor.color, coauthor.hasRing) }}
      />
    ),
  };
  return (
    <li role="presentation" style={getCoauthorSectionStyle(palette).item} key={coauthorMenuItemProps.key}>
      <BaseButton {...coauthorMenuItemProps} />
    </li>
  );
};
